import { Link } from 'react-router-dom';
import { useRouteMatch } from 'react-router';
import styled from 'styled-components';
import { kebabCase } from 'utils/stringHelpers';
import { SideNavLinkConfig } from './types';
import { getSideNavAnchorTagStyles } from './utils';

type SideNavLinkProps = SideNavLinkConfig & { isSubLink?: boolean };

const SideNavLinkWrapper = styled.li<{ isActive?: boolean; isSubLink?: boolean }>`
  padding: 0;

  && a {
    ${({ isActive, isSubLink }) => getSideNavAnchorTagStyles(isActive, isSubLink)}
  }
`;

export const SideNavLink: React.FC<React.PropsWithChildren<SideNavLinkProps>> = ({
  search = '',
  name,
  pathname,
  exact,
  children,
  hash,
  isSubLink,
}) => {
  const path = hash ? `${pathname}${hash}` : pathname;
  const isActive = !!useRouteMatch({ exact, path });
  return (
    <SideNavLinkWrapper
      isActive={isActive}
      isSubLink={isSubLink}
      data-test={isActive ? 'active-page' : null}
    >
      <Link to={{ search, pathname, hash }} data-test={`side-nav-link-${kebabCase(name)}`}>
        {children}
      </Link>
    </SideNavLinkWrapper>
  );
};
